export default {
  english: {
    subscribeToOurNewsletter: 'Subscribe to our newsletter',
    stayUpdated: 'Stay updated',
    subscribe: 'Subscribe',
    subscriptionError: 'An error occurred',
    subscriptionSuccess: 'Subscribed',
    play: 'Play the video',
    link: '/en/newsletter',
    live: 'Live',
    close: 'Close video',
  },
  french: {
    subscribeToOurNewsletter: 'Abonnez-vous à notre newsletter',
    stayUpdated: 'Restez à jour',
    subscribe: 'S\'abonner',
    subscriptionError: 'Une erreur est survenue',
    subscriptionSuccess: 'Abonné',
    play: 'Lancer la video',
    link: '/fr/newsletter',
    live: 'En direct',
    close: 'Fermer la vidéo',
  },
  arabic: {
    subscribeToOurNewsletter: 'اشترك في النشرة الإخبارية',
    stayUpdated: 'ابقى على إطلاع',
    subscribe: 'إشترك',
    subscriptionError: 'حدث خطأ',
    subscriptionSuccess: 'مشترك',
    play: 'قم بتشغيل الفيديو',
    link: '/ar/النشرة الإخبارية',
    live: 'مباشر',
    close: 'إغلاق الفيديو',
  },
  hebrew: {
    subscribeToOurNewsletter: 'הירשם לניוזלטר',
    stayUpdated: 'הישאר מעודכן',
    subscribe: 'הירשם',
    subscriptionError: 'אירעה שגיאה',
    subscriptionSuccess: 'נרשם',
    play: 'נגן את הסרטון',
    link: '/he/newsletter',
    live: 'שידור ישיר',
    close: 'סגור וידאו',
  },
  persian: {
    subscribeToOurNewsletter: 'در خبرنامه ما مشترک شوید',
    stayUpdated: 'به روز باشید',
    subscribe: 'مشترک شوید',
    subscriptionError: 'خطایی رخ داد',
    subscriptionSuccess: 'مشترک شد',
    play: 'ویدیو را پخش کنید',
    link: '/fa/newsletter',
    live: 'زندگی کنید',
    close: 'بستن ویدیو',
  },
}
